const hasCapability = (user, capabilityType) => !!user?.capabilities?.some(el => el?.capabilityType === capabilityType)

export const isPayTerminalOnly = (user) => hasCapability(user, 'PAY') && !hasCapability(user, 'POS')

export const isReservationOnly = (user) => hasCapability(user, 'RESERVATION') && !hasCapability(user, 'POS')

export const hasReservationCapability = (user) => hasCapability(user, 'RESERVATION')
